import {
    AssortmentListDetailViewModel,
    AssortmentListOverviewViewModel,
    AssortmentListSharedViewModel,
    AssortmentListViewModel,
    CreateAssortmentListRequest,
    CustomerViewObject,
    UpdateAssortmentListCustomersRequest,
    UpdateAssortmentListRequest,
    UpdateAssortmentListUsersRequest,
    UpdateProductsAssortmentListRequest,
    UserViewObject
} from '@/types/apiServerContract';
import httpService from '@/core/http/http.service';
import { createUrlFactory } from '@/project/http/ApiHelper.service';
import { AxiosResponse } from 'axios';

export class AssortmentListsController {
    private readonly urlFactory = createUrlFactory('assortmentlist');

    public async AssortmentLists(): Promise<AssortmentListOverviewViewModel> {
        return httpService.get(this.urlFactory('all'));
    }

    public async create(request: CreateAssortmentListRequest, messageId?: string): Promise<AssortmentListViewModel> {
        return httpService.post(this.urlFactory('create'), request, messageId);
    }

    public async update(request: UpdateAssortmentListRequest, messageId?: string): Promise<AssortmentListViewModel> {
        return httpService.post(this.urlFactory('update'), request, messageId);
    }

    public async updateProducts(request: UpdateProductsAssortmentListRequest, messageId?: string): Promise<AssortmentListViewModel> {
        return httpService.post(this.urlFactory('updateproducts'), request, messageId);
    }

    public async updateUsers(request: UpdateAssortmentListUsersRequest, messageId?: string): Promise<AssortmentListViewModel> {
        return httpService.post(this.urlFactory('updateusers'), request, messageId);
    }

    public async updateCustomers(request: UpdateAssortmentListCustomersRequest, messageId?: string): Promise<AssortmentListViewModel> {
        return httpService.post(this.urlFactory('updatecustomers'), request, messageId);
    }

    public async getAssortmentList(id: string): Promise<AssortmentListViewModel | undefined> {
        if (!id) return;
        return httpService.get(this.urlFactory(`get/${id}`));
    }

    public async getSharedAssortmentList(id: string): Promise<AssortmentListSharedViewModel | undefined> {
        if (!id) return;
        return httpService.get(this.urlFactory(`shared/${id}`));
    }

    public async extendAssortmentList(id: string): Promise<string> {
        return httpService.get(this.urlFactory(`extend/${id}`));
    }

    public async copyAssortmentList(id: string, messageId?: string): Promise<string> {
        return httpService.get(this.urlFactory(`copy/${id}`));
    }

    public async getDetailsAssortmentList(id: string): Promise<AssortmentListDetailViewModel | undefined> {
        if (!id) return;
        return httpService.get(this.urlFactory(`details/${id}`));
    }

    public async deleteAssortmentList(id: string, messageId?: string): Promise<AssortmentListDetailViewModel | undefined> {
        if (!id) return;
        return httpService.delete(this.urlFactory(`delete/${id}`), undefined, undefined, messageId);
    }

    public async searchUsers(term: string): Promise<UserViewObject[]> {
        return httpService.get(this.urlFactory('searchusers'), { term }, 'searchUser');
    }

    public async searchCustomers(term: string): Promise<CustomerViewObject[]> {
        return httpService.get(this.urlFactory('searchcustomers'), { term }, 'searchCustomer');
    }

    public async export(id: string, messageId?: string): Promise<any> {
        const result = await httpService.post<AxiosResponse>(this.urlFactory(`export/${id}`),
            undefined,
            messageId,
            undefined,
            {
                responseType: 'blob'
            },
            true);

        const fileName = httpService.getContentDispositionFilename(result);
        const file = result.data as Blob;

        return {
            fileName,
            file
        };
    }
}
